import { useList } from '@refinedev/core';
import { useCallback, useEffect, useState } from 'react';

import { PackageItem } from '@/model/Logistic/PackageItem/PackageItem';
import { useRepositoriesContext } from '@/repositories/RepositoriesContext';

const usePackageItemsList = (packageItems, setPackageItems, packageId) => {
  const { packageItemRepository } = useRepositoriesContext();
  const [initializedPackageItems, setInitializedPackageItems] = useState(false);
  const {
    result: packageItemsResult,

    query: { isLoading, isFetching, refetch, isFetchedAfterMount },
  } = useList<PackageItem>({
    resource: 'packages_items',
    pagination: { pageSize: 1000 },
    meta: {
      package: packageId,
    },
    queryOptions: {
      enabled: packageId !== undefined,
      staleTime: 0,
    },
  });

  useEffect(() => {
    if (isFetchedAfterMount && packageItemsResult && !initializedPackageItems) {
      setPackageItems(packageItemsResult.data);
      setInitializedPackageItems(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packageItemsResult, isFetchedAfterMount]);

  const handleDelete = useCallback(
    record => {
      const itemFounded = packageItems.find(item =>
        record.id ? item.id == record.id : item.name == record.name,
      );

      if (!itemFounded) return;

      const itemDeleted: PackageItem = { ...itemFounded, toDelete: true };
      const newPackageItems = packageItems.map(item =>
        item.id
          ? item.id === itemDeleted.id
            ? itemDeleted
            : item
          : item.name === itemDeleted.name
            ? itemDeleted
            : item,
      );

      setPackageItems(newPackageItems);
    },
    [packageItems, setPackageItems],
  );
  const saveItems = useCallback(async () => {
    if (packageId == undefined) return;
    await packageItemRepository.savePackageItems(packageItems, packageId).then(() => {
      void refetch().then(({ data }) => {
        if (data) {
          setPackageItems(data.data);
        }
      });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packageItems]);

  return { isLoading, isFetching, refetch, handleDelete, saveItems };
};

export default usePackageItemsList;
